import {styled} from '@mui/material/styles'
import {Box} from '@mui/material'

export const StyledBox = styled(Box, {shouldForwardProp: (prop) => prop !== 'changeBackgroundColor'})(
  ({theme, changeBackgroundColor}) => ({
    flexGrow: 1,
    bgcolor: theme.palette.errieBlack,
    padding: '22px',
    overflowX: 'auto',
    height: changeBackgroundColor ? '100vh' : 'auto',
    backgroundColor: changeBackgroundColor ? theme.palette.blackShade : ''
  })
)
